import { createAction, props } from '@ngrx/store';
import { CurrencyDto } from '@app-generated/models/currency-dto';

export const setCurrencies = createAction('[Currencies] Set', props<{ currencies: CurrencyDto[] }>());

export const loadCurrencies = createAction('[Currencies] Load');
